import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import * as firebase from 'firebase/app';
import { IdentityService } from '../identity.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  constructor(
    public fireAuth: AngularFireAuth,
    private identityService: IdentityService
  ) {}

  public ngOnInit(): void {}

  public loginWithGoogle() {
    this.fireAuth.auth
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then((result) => this.identityService.handleAuthenticationReroute(result.user));
  }

  /*public signupWithGoogle() {
    this.fireAuth.auth
      .signInWithPopup(new firebase.auth.GoogleAuthProvider())
      .then((result) => 
      this.identityService.handleThirdPartySignupAuthenticationReroute(result.user))
      .catch((error) =>
      {
        var errorCode = error.code;
        var errorMessage = error.message;
        var email = error.email;
        var credential = error.credential;
      });
  }*/
}
